var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMulticotizadorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#663ea8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_24",
    "data-name": "Capa 24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.5,8.83a1,1,0,0,0-.42.86.79.79,0,0,0,.24.61,1.61,1.61,0,0,0,.6.36l.1,0V8.58A2.08,2.08,0,0,0,10.5,8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.29,12.41l-.09,0v2a2,2,0,0,0,.47-.21,1,1,0,0,0,.42-.85.68.68,0,0,0-.23-.54A1.64,1.64,0,0,0,12.29,12.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.45,4.76,11.9,1.41a.93.93,0,0,0-.8,0L3.65,4.72a1.07,1.07,0,0,0-.65,1v5a11.49,11.49,0,0,0,8.22,11,1.06,1.06,0,0,0,.56,0,11.49,11.49,0,0,0,8.22-11v-5A.94.94,0,0,0,19.45,4.76Zm-5.53,10a3,3,0,0,1-1.71.79v.72a.62.62,0,0,1-.16.43.56.56,0,0,1-.43.16.54.54,0,0,1-.42-.16.58.58,0,0,1-.16-.43v-.7a5.42,5.42,0,0,1-1.27-.27,3.56,3.56,0,0,1-1.07-.57.55.55,0,0,1-.2-.23.57.57,0,0,1-.06-.31.71.71,0,0,1,.14-.43.43.43,0,0,1,.33-.18.52.52,0,0,1,.21,0l.26.13a4.46,4.46,0,0,0,1,.5,4.56,4.56,0,0,0,.62.13V12.05a10.87,10.87,0,0,1-1.1-.36A2.41,2.41,0,0,1,9,11a1.81,1.81,0,0,1-.39-1.24,2.1,2.1,0,0,1,.67-1.58A3,3,0,0,1,11,7.37V6.65a.58.58,0,0,1,.16-.43.54.54,0,0,1,.42-.16.56.56,0,0,1,.43.16.62.62,0,0,1,.16.43v.71a3.93,3.93,0,0,1,2,.84.64.64,0,0,1,.28.54.66.66,0,0,1-.15.42.44.44,0,0,1-.33.19.65.65,0,0,1-.2,0,1.08,1.08,0,0,1-.26-.14,4.55,4.55,0,0,0-.89-.49,2.2,2.2,0,0,0-.44-.12V11a9.72,9.72,0,0,1,1.08.35,2.27,2.27,0,0,1,.9.66,1.8,1.8,0,0,1,.38,1.2A2.11,2.11,0,0,1,13.92,14.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMulticotizadorActive);
export default __webpack_public_path__ + "static/media/ic-multicotizador-active.b57c274f70cc0b4ef36a147d59aa2b33.svg";
export { ForwardRef as ReactComponent };